import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FuseSharedModule } from '@fuse/shared.module';
import { VerificationCodeComponent } from './verification-code.component';

@NgModule({
  declarations: [
    VerificationCodeComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    FuseSharedModule,
  ],
  exports: [
    VerificationCodeComponent
  ]
})
export class VerificationCodeModule { }
